import { ComponentProps } from 'react';
import clsx from 'clsx';

import styles from './Badge.module.css';

interface BadgeProps extends ComponentProps<'span'> {
  variant?: 'primary' | 'secondary' | 'secondaryLight';
  compact?: boolean;
}

export default function Badge({ variant = 'secondary', className, children, compact, ...props }: BadgeProps) {
  return (
    <span
      className={clsx(styles.badge, styles[variant], compact && styles.compact, className)}
      {...props}
    >
      {children}
    </span>
  );
}
